import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** AI import. A wand turning a messy note into sparkles. */
export function MagicWand(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <ellipse cx="80" cy="144" rx="44" ry="5" style={{ fill: sc('border.default') }} />
      <rect
        x="22"
        y="70"
        width="58"
        height="66"
        rx="8"
        transform="rotate(-8 51 103)"
        style={{ fill: sc('bg.surface'), stroke: sc('border.strong'), strokeWidth: 3 }}
      />
      <path
        d="M34 88c8-4 14 4 22 0s12-2 16 0M34 104c10-3 18 3 28 0M36 120c6-2 12 2 20 0"
        style={{ fill: 'none', stroke: c('neutral.400'), strokeWidth: 4, strokeLinecap: 'round' }}
      />
      <g transform="rotate(40 110 70)">
        <rect x="104" y="44" width="12" height="76" rx="6" style={{ fill: c('neutral.800') }} />
        <rect x="104" y="44" width="12" height="16" rx="6" style={{ fill: c('neutral.0') }} />
      </g>
      <path d="M92 32l4 10 10 4-10 4-4 10-4-10-10-4 10-4z" style={{ fill: c('gold.400') }} />
      <path
        d="M126 20l2.5 6 6 2.5-6 2.5-2.5 6-2.5-6-6-2.5 6-2.5z"
        style={{ fill: c('blue.400') }}
      />
      <path
        d="M136 56l2 4.5 4.5 2-4.5 2-2 4.5-2-4.5-4.5-2 4.5-2z"
        style={{ fill: c('berry.300') }}
      />
      <circle cx="70" cy="30" r="3" style={{ fill: c('mint.300') }} />
    </IllustrationFrame>
  );
}
